<template>
  <service-autocomplete
    :search-attributes-array="['id', 'name', 'short_name']"
    :value="value"
    v-bind="$attrs"
    ref="autocomplete"
    @input="handleInputChange"
    @clear-items="$emit('clear-items')"
    :url="url"
    cache-items
    :use-entities="useEntities"
    :id-field="idField"
    nav-full-id-field="nav_full_id"
    dense
    multiple
    outlined
    :label="generateMessage('boilerplate.filters.entity')"
  >
    <template v-slot:item="{ item }">
      {{ item.id + ' - ' + item.short_name }}
    </template>
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :value="data.selected"
        close
        small
        @click:close="$refs.autocomplete.handleInputRemove(data.item)"
      >
        {{ data.item.id }}
      </v-chip>
    </template>
  </service-autocomplete>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import ServiceAutocomplete from '@/components/selects/ServiceAutocomplete';

export default {
  name: 'ServiceEntitySelector',
  components: { ServiceAutocomplete },
  props: {
    value: { type: Array, required: false },
    useEntities: { type: Boolean, required: false },
    idField: { type: String, required: false, default: 'nav_full_id' },
  },
  data() {
    return {
      module: {},
      entitiesSearchQuery: null,
      url: `${process.env.USER_PREFERENCES_BASE_URI}/entities`,
    };
  },
  methods: {
    generateMessage,
    handleInputChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>
